import { useState, useEffect } from "react";
import {errorStatusHandle} from "../utils/error-utils";
import {getUnfinished} from "../api/inspections/unfinishedApi";
import {
  clearComponentLoading,
  clearPageLoading,
  setAlertError,
  setComponentLoading,
  clearButtonProcessing,
  setButtonProcessing
} from "../store/actions";
import _ from 'lodash';
import {getFormErrorResponseData} from "../utils";
import {useDispatch} from "react-redux";

const useUnfinished= (reload, filter = {}, buttonSearchId) => {
  const dispatch = useDispatch();
  const [unfinished, setUnfinished] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [numPages, setNumPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState(filter);
  const [orderList, setOrderList] = useState({});
  const [errors, setErrors] = useState({});

  const setAlertErrorMessages = (response) => {
    const errorItems = [];
    if (!_.isEmpty(response.error_message)) {
      errorItems.push(response.error_message);
    }
    if (!_.isEmpty(response.errors)) {
      const errors = response.errors;
      for (const key in errors) {
        errorItems.push("・" + errors[key]);
      }
    }
    dispatch(setAlertError(errorItems));
  };

  const getParamsSort = (orderList) => {
    let sort = [];
    for (const [column, order] of Object.entries(orderList)) {
      if (order !== 0) {
        let orderDirection = order === 1 ? '_asc' : '_desc';
        sort.push(column + orderDirection)
      }
    }
    sort = sort.join(",");
    return sort;
  }

  useEffect(() => {
    dispatch(setComponentLoading("unfinished-action-list"));
    let sort = getParamsSort(orderList);
    if (reload) {
      dispatch(setButtonProcessing(buttonSearchId));
      const searchParams = {};
      Object.keys(filters).forEach(key => {
        if (Array.isArray(filters[key])) {
          searchParams[key] = filters[key].join(',');
        } else {
          searchParams[key] = filters[key];
        }
      });
      getUnfinished(currentPage, pageSize, searchParams, sort).then((response) => {
        if (response.success) {
          setErrors({});
          setUnfinished(response.data.inspections);
          setTotalCount(response.data.pagination.total_count);
          setNumPages(response.data.pagination.total_pages);
          dispatch(clearPageLoading());
          dispatch(clearComponentLoading("unfinished-action-list"));
        }
      }).catch(e => {
        errorStatusHandle(e);
        if (e.response.status === 400) {
          setUnfinished([]);
          let errorResponse = getFormErrorResponseData(e);
          setErrors(errorResponse.errors);
          if (errorResponse) {
            setAlertErrorMessages(errorResponse);
          }
        }
      }).finally(() => {
        if (reload) {
          dispatch(clearButtonProcessing(buttonSearchId));
          dispatch(clearPageLoading());
          dispatch(clearComponentLoading("unfinished-action-list"));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderList, filters, currentPage, pageSize, reload]);

  return { unfinished, currentPage, pageSize, numPages, totalCount, filters, orderList, errors,
    setCurrentPage, setPageSize, setNumPages, setTotalCount, setFilters, setOrderList };
}

export default useUnfinished